import { Component } from '@angular/core';
import { LayoutService } from '../../shared/services/layout.service';

@Component({
	selector: 'admin-home',
	templateUrl: 'admin-home.component.html'
})
export class AdminHomeComponent {

    constructor(
        private _layoutService: LayoutService
	){}
	
    ngOnInit(){
        this._layoutService.setCurrentPage('admin-home');
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/home/components/admin-home.component.ts